export default __webpack_public_path__ + "static/media/CarInteriorDetailing.b41ef5a3.webp";